import type { RestaurantShortDTO } from 'shared/types/api'
import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    error?: any,
    networkError?: any,
    deliveryFocused: boolean,
    dataLoaded?: boolean,
    sendEmailSuccess: boolean,
    sendEmailError: ?string,
    geocodingError: any,
    address: string,
    geocodedAddress: ?Coordinates,
    restaurants: ?Array<RestaurantShortDTO>
}

export const initialState: State = {
    metaData: {
        canonicalURL: '',
        keywords: '',
        seoDescription: '',
        title: ''
    },
    deliveryFocused: false,
    dataLoaded: false,
    sendEmailSuccess: false,
    sendEmailError: null,
    geocodingError: false,
    address: '',
    geocodedAddress: null,
    restaurants: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_DELIVERY_RESPONSE':
            return {
                ...state,
                ...action.data,
                deliveryFocused: true,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'DELIVERYPAGE_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'DELIVERY_SEND_EMAIL_SUCCESS':
            return {
                ...state,
                sendEmailSuccess: true,
                sendEmailError: null
            }
        case 'DELIVERY_SEND_EMAIL_ERROR':
            return {
                ...state,
                sendEmailSuccess: false,
                sendEmailError: action.sendEmailError
            }
        case 'DELIVERY_SEND_EMAIL_RESET':
            return {
                ...state,
                sendEmailSuccess: false,
                sendEmailError: null
            }
        case 'DELIVERY_PAGE_RESET':
            return {
                ...state,
                deliveryFocused: false
            }
        case 'SEARCH_RESULTS':
            if (action.fromDelivery) {
                return {
                    ...state,
                    geocodingError: false,
                    address: action.address,
                    geocodedAddress: action.geocodedAddress,
                    restaurants: action.restaurants
                }
            }
            return state
        case 'CLEAR_SEARCH':
            if (action.fromDelivery) {
                return initialState
            }
            return state
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.delivery)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
